import { DataService } from "../auth/DataService";
import { backend_url } from "../auth/setting";

// Helper function to handle the Fetch API responses
const handleResponse = async (response) => {
  let responseData;
  
  try {
    const text = await response.text(); // Read the response as plain text
    
    // Attempt to parse the text as JSON, if possible
    responseData = text ? JSON.parse(text) : {}; 
  } catch (error) {
    // If parsing fails, fall back to the raw text
    throw new Error("Failed to parse JSON response. Response text: " + error.message);
  }
  
  if (!response.ok) {
    // If the response is not OK, throw an error with the parsed data (if available)
    const errorMessage = responseData.message || "Something went wrong";
    throw new Error(errorMessage);
  }

  return responseData;
};

// Function to handle GET requests
export const getData = async (endpoint) => {
  const url = `${backend_url}${endpoint}`;
  
  const response = await fetch(url, {
    method: "GET",
    mode: "cors",
    headers: DataService.getFetchHeader(),
  });
  
  return handleResponse(response);
};

// API call functions
export const getVesselReportViews = async (id) => {
  return await getData(`/vessel/vesselReportView`);
};

export const getVesselReportHPEView = async (idVesselReport, countryCode) => {
  return await getData(`/vessel/vesselReportHPEView/${idVesselReport}/${countryCode}`);
};

export const getVesselReportHPEDayView = async (idReportHPE) => {
  return await getData(`/vessel/vesselReportHPEDayView/${idReportHPE}`);
};

export const getVesselReportShipowner = async (idReportShipowner) => {
  return await getData(`/vessel/VesselReportShipowner/${idReportShipowner}`);
};

export const getVesselReport = async (id) => {
  return await getData(`/vessel/vesselReport/${id}`);
};
export const getVesselReportMarketSumView = async (idVesselReport) => {
  return await getData(`/vessel/vesselReportHPEMarketSumView/${idVesselReport}`);
};

export const getVesselReportPortSumView = async (idVesselReport, countryCode) => {
  return await getData(`/vessel/vesselReportHPEMarketView/${idVesselReport}/${countryCode}`);
};